
<div class="open-chat" @click="$emit('expand')">
  <img class="crow_avatar" src="../assets/crow_avatar.png" alt=""/>
</div>
